import { z } from "zod";

import { alphanumeric, alphanumericAndSlash } from "utils/regex";

export const physicalFormValidator = z
  .object({
    size: z.string().optional(),
    email: z
      .string({ required_error: "Field is required" })
      .trim()
      .email({ message: "It's not a valid e-mail address" }),
    firstName: z
      .string({ required_error: "Field is required" })
      .trim()
      .regex(alphanumeric, {
        message: "Field has not supported characters",
      }),
    lastName: z
      .string({ required_error: "Field is required" })
      .trim()
      .regex(alphanumeric, {
        message: "Field has not supported characters",
      }),
    phoneNumber: z.string({ required_error: "Field is required" }).trim(),
    country: z
      .string({ required_error: "Field is required" })
      .trim()
      .regex(alphanumeric, {
        message: "Field has not supported characters",
      }),
    city: z
      .string({ required_error: "Field is required" })
      .trim()
      .regex(alphanumeric, {
        message: "Field has not supported characters",
      })
      .min(3, { message: "Field requires a minimum of 3 characters" }),
    state: z
      .string()
      .trim()
      .regex(alphanumeric, {
        message: "Field has not supported characters",
      })
      .min(3, { message: "Field requires a minimum of 3 characters" })
      .nullable()
      .optional(),
    address: z
      .string({ required_error: "Field is required" })
      .trim()
      .regex(alphanumericAndSlash, {
        message: "Field has not supported characters",
      }),
    apartment: z
      .string()
      .trim()
      .regex(alphanumericAndSlash, {
        message: "Field has not supported characters",
      })
      .nullable()
      .optional(),
    postalCode: z
      .string({ required_error: "Field is required" })
      .trim()
      .regex(alphanumeric, {
        message: "Field has not supported characters",
      }),
    termsChecked: z.boolean().refine((val) => !!val, {
      message: "The terms and conditions must be accepted.",
    }),
    personalDataChecked: z.boolean().refine((val) => !!val, {
      message: "The person data consent must be accepted.",
    }),
    marketingChecked: z.boolean().nullable().optional(),
    requiredSize: z.boolean().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (!!data.requiredSize && !data.size) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["size"],
        message: "Field is required",
      });
    }
  });

export const decentralandFormValidator = z.object({
  nickname: z
    .string({ required_error: "Field is required" })
    .trim()
    .regex(alphanumeric, {
      message: "Field has not supported characters",
    }),
  email: z
    .string({ invalid_type_error: "Field is required" })
    .trim()
    .email({ message: "It's not a valid e-mail address" }),
  personalDataChecked: z.boolean().refine((val) => !!val, {
    message: "The person data consent must be accepted.",
  }),
  marketingChecked: z.boolean().nullable().optional(),
});
